import { Link } from '@tanstack/react-router';
import { useSession } from '../lib/session.tsx';
import { STAFF_EMPLOYEES_PATH } from '../settings-pages.ts';
import { NoticeCard } from './ui/notice-card.tsx';
import { buttonClass } from './ui/variants.ts';

export const NO_EMPLOYEE_TEXTS = {
  title: 'Für Sie ist noch kein Mitarbeiter angelegt.',
  admin: 'Legen Sie unter Einstellungen › Zeiterfassung › Mitarbeiter einen Mitarbeiter für sich an – danach können Sie stempeln.',
  adminAction: 'Mitarbeiter anlegen',
  other: 'Bitte beim Admin melden.',
} as const;

/**
 * Leerzustand „kein Mitarbeiter“ der Zeiterfassung (Ticket 1.284 Nacharbeit, EK8: Leerzustand mit nächstem Schritt) für
 * Heute, Meine Zeiten, Urlaub und Kalender: Hinweis-Karte (info) mit genau einem Hauptknopf – der Admin kommt mit
 * „Mitarbeiter anlegen“ zu Einstellungen › Zeiterfassung › Mitarbeiter; alle anderen lesen nur „Bitte beim Admin melden.“
 * (kein Schein-Kontaktlink).
 */
export function NoEmployeeNotice({ testId = 'kein-mitarbeiter' }: { testId?: string }) {
  const { me } = useSession();
  const admin = me.role === 'admin';
  return (
    <NoticeCard
      tone="info"
      testId={testId}
      title={NO_EMPLOYEE_TEXTS.title}
      action={
        admin ? (
          <Link to={STAFF_EMPLOYEES_PATH} data-testid="kein-mitarbeiter-anlegen" className={buttonClass('primary', 'sm')}>
            {NO_EMPLOYEE_TEXTS.adminAction}
          </Link>
        ) : undefined
      }
    >
      {admin ? NO_EMPLOYEE_TEXTS.admin : NO_EMPLOYEE_TEXTS.other}
    </NoticeCard>
  );
}
